<template>
  <div style="padding-top: -2px; margin-top: -2px">
    <v-label v-if="label && showTopLabel"><b>{{ label }}</b></v-label>
    <v-autocomplete
      v-model="internalValue"
      :items="users"
      :loading="loading"
      :disabled="disabled"
      :clearable="clearable"
      :label="showTopLabel ? '' : label"
      item-value="UsrID"
      :item-text="getItemText"
      dense
      outlined
      hide-details="auto"
      class="mt-1"
      placeholder="Seleccionar Usuario / Responsable..."
      no-data-text="No se encontraron usuarios activos"
      @change="onChange"
    >
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium">
            {{ item.UsrFullName || item.UsrName || item.UsrLogin }}
          </v-list-item-title>
          <v-list-item-subtitle class="caption grey--text">
            {{ item.AreName || 'Sin Gerencia' }} | {{ item.UsrLogin }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import _sUserService from "@/services/Security/UserService";

export default {
  name: "SSelectUser",
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    label: {
      type: String,
      default: "Usuario / Responsable"
    },
    clearable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showTopLabel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalValue: this.value,
      users: [],
      loading: false
    };
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal;
    },
    internalValue(newVal) {
      this.$emit("input", newVal);
    }
  },
  created() {
    this.loadUsers();
  },
  methods: {
    getItemText(item) {
      if (!item) return "";
      return item.UsrFullName || item.UsrName || item.UsrLogin || "";
    },
    loadUsers() {
      this.loading = true;
      const requestID = this.$fun ? this.$fun.getUserID() : 0;
      _sUserService.listActive(requestID)
        .then(response => {
          if (response && response.data) {
            this.users = response.data || [];
          }
        })
        .catch(err => {
          console.error("Error al cargar lista de usuarios:", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onChange(val) {
      const selectedObj = this.users.find(u => u.UsrID === val) || null;
      this.$emit("change", val, selectedObj);
    }
  }
};
</script>
